import { lazyInject } from '@intelingu/core/IoC/container';
import { UserStore } from '@intelingu/core/stores/UserStore';
import * as React from "react";
import { Component } from "react";
import { hot } from "react-hot-loader";
import { BrowserRouter } from "react-router-dom";
import { Achievement } from './partials/Achievement';
import { ConnectionErrorMessage } from './partials/ConnectionErrorMessage';
import { Router } from './Router';

export interface AppProps {
}

class App extends Component<AppProps, undefined> {

    @lazyInject(UserStore) userStore: UserStore;

    render() {
        return <>
            <BrowserRouter>
                <Router />
            </BrowserRouter>

            <ConnectionErrorMessage />
            <Achievement />
        </>
    }

}

export default hot(module)(App);
